import Container from "@/components/Container/Container";
import Layout from "@/components/Layout/Layout";
import SignUp from "@/components/SignUp/SignUp";
import SignupPromoPanel from "@/components/SignUp/SignupPromoPanel";
import { mq } from "@/constants/breakpoints";
import { getSignUpPage } from "@/utils/getSignUpPage";
import { css } from "@emotion/react";
import { GetStaticProps } from "next";

const Page = ({ pageTitle, metaDescription, benefits }: any) => {
  return (
    <Layout title={pageTitle} metaDescription={metaDescription}>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          ${mq["lg"]} {
            flex-direction: row;
          }
        `}
      >
        <Container
          css={css`
            margin-top: 24px;
            margin-bottom: 60px;
            flex: 45;
            ${mq["lg"]} {
              margin-top: 44px;
            }
          `}
        >
          <SignUp />
        </Container>
        <SignupPromoPanel data={{ benefits }} />;
      </div>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: await getSignUpPage(),
  };
};

export default Page;
